export default () => ({
  page: null,
  errorState: [],
  formPosted: false,
  init() {
    this.page = window.location.pathname;
  },
  checkErrorState(errorState) {
    if ([...this.errorState].includes(errorState)) {
      return true;
    }
    return false;
  },
  submitRegisterForm(currentUrl) {
    const form = document.getElementById("register_section_form");
    const email = document.getElementById("register_section_email");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const password = document.getElementById("register_section_password");
    const confirmPassword = document.getElementById(
      "register_section_password_confirm"
    );
    this.errorState = [];

    if (!emailRegex.test(email.value)) {
      this.errorState.push("email_invalid");
      return;
    }

    if (password.value.length < 8) {
      this.errorState.push("password_length");
      return;
    } else if (confirmPassword.value === "") {
      this.errorState.push("password_confirm");
      return;
    } else if (password.value !== confirmPassword.value) {
      this.errorState.push("password_match");
      return;
    }

    const formData = new FormData(form);

    fetch("/account", {
      method: "POST",
      body: formData,
    }).then((response) => {
      const emailIsUsed = response.url.includes("register");

      if (emailIsUsed) {
        this.errorState.push("email_used");
      } else {
        // Set genderString
        CF.customerReady(
          function () {
            const genderString = CF.customer.get("preference_gender") || null;

            if (!genderString) {
              CF.customer.update({
                preference_gender: "unisex",
              });

              fetch(`${shopUrl}/apps/jl-api/frontend/voyado/contact`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  data: {
                    clothingGender: ["unisex"],
                  },
                }),
              })
                .then((response) => {
                  //return response.json();
                })
                .then((response) => {
                  //console.log(response);
                });
            }
          }.bind(this)
        );

        window.location.href = currentUrl + "?login=true";
      }
    });
  },
});
